import { render, staticRenderFns } from "./IconDone.vue?vue&type=template&id=2f1940e8&"
import script from "./IconDone.vue?vue&type=script&lang=js&"
export * from "./IconDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports